import { render, staticRenderFns } from "./DynamicFields.vue?vue&type=template&id=265fd538&scoped=true&"
import script from "./DynamicFields.vue?vue&type=script&lang=js&"
export * from "./DynamicFields.vue?vue&type=script&lang=js&"
import style0 from "./DynamicFields.vue?vue&type=style&index=0&id=265fd538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265fd538",
  null
  
)

export default component.exports